/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_DeadlineInputs */

const vi_sla_deadline = /** @type {(inputs: Sla_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạn SLA`)
};

/**

* @param {Sla_DeadlineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_deadline = /** @type {((inputs?: Sla_DeadlineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_DeadlineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_deadline(inputs)
});